import { systemAppCode, explanationData, riskListData} from './constant';

export const getRiskList = (appCode: string, roleType: string) => {
  if(systemAppCode.campusMiniprogram === appCode) {
    if(roleType === 'parents') {
      return riskListData['campusMiniProgramParent'];
    }
    return riskListData['campusMiniProgramTeacher'];
  }
  return riskListData[appCode] || [];
};

export const getExplanationList = (appCode: string, roleType: string) => {
  if(systemAppCode.campusMiniprogram === appCode) {
    if(roleType === 'parents') {
      return explanationData['campusMiniProgramParent'];
    }
    return explanationData['campusMiniProgramTeacher'];
  }
  return explanationData[appCode] || [];
};

